var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"auth",attrs:{"id":"auth"}},[_c('section',{staticClass:"content"},[_vm._t("default")],2),_c('img',{staticClass:"card-img",attrs:{"src":require("@/assets/images/Image11.webp")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }